export default "__VITE_ASSET__KTnDvYIP__"